import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export type SDKConfig = {
  binaah_sdk_key: string;
  scan_duration: number;
};
interface FaceScanState {
  sdkConfig: SDKConfig | null;
  includeDemographic: boolean;
  presignedUrls: {
    video: string | null;
    json: string | null;
  };
  isVideoStreamStopped: boolean;
}

interface FaceScanAction {
  setSDKConfig: (config: SDKConfig) => void;
  setIncludeDemographic: (include: boolean) => void;
  setPresignedUrls: (urls: {
    video: string | null;
    json: string | null;
  }) => void;
  setIsVideoStreamStopped: (isStopped: boolean) => void;
  clearScanStore: () => void;
}

const initialState: FaceScanState = {
  sdkConfig: null,
  includeDemographic: false,
  presignedUrls: {
    video: null,
    json: null,
  },
  isVideoStreamStopped: false,
};

type FaceScanStore = FaceScanState & FaceScanAction;

const useFaceScanStore = create<FaceScanStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setSDKConfig: (config: SDKConfig) => set({ sdkConfig: config }),
        setIncludeDemographic: (include: boolean) =>
          set({ includeDemographic: include }),
        setPresignedUrls: (urls) => set({ presignedUrls: urls }),
        setIsVideoStreamStopped: (isStopped) => set({ isVideoStreamStopped: isStopped }),
        clearScanStore: () => set(initialState),
      }),
      { name: 'face-scan' }
    )
  )
);

export default useFaceScanStore;
